/**
 * The purpose of RebuyProducts class is get and render product from Rebuy widget.
 */
class RebuyProducts extends window.SliderComponent {
  /**
   * The constructor method is a special method of a class for creating
   * and initializing an object instance of that class.
   */
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    if (!this.slider) return;
    this.sliderItems = this.querySelectorAll(`[id="${this.slider.id}"] > [id^="Slide-"]`);
    const {
      stickySidget,
      columnsMobile,
      columnsDesktop,
      api,
      identifier,
      sections,
      productId,
      collectionId,
      pagePath,
      customerId,
      when,
      limit,
    } = this.dataset;
    this.stickySidget = stickySidget === 'true';
    this.columnsMobile = Number(columnsMobile) || 0;
    this.columnsDesktop = Number(columnsDesktop) || 0;
    this.api = api;
    this.identifier = identifier;
    this.sections = sections || '';
    this.productId = productId || '';
    this.collectionId = collectionId || '';
    this.pagePath = pagePath || '';
    this.customerId = customerId || '';
    this.url = window.location;
    this.ul = this.querySelector('ul');
    this.li = this.querySelector('template');
    this.limit = limit;
    this.when = when;
    this.querySelector('template')?.remove();
    if (
      when === undefined
    ) this.findRebuyWidget();
    if (
      when === undefined
      && this.api
      && this.identifier
    ) this.findRebuyWidget();

    if (when === 'load') RebuyProducts.setCartData();
    else if (when === 'change') document.addEventListener('rebuy.ready', () => document.addEventListener('rebuy:cart.change', RebuyProducts.setCartData));
    document.addEventListener('rebuy-products:cart-update', RebuyProducts.rebuildPopUps);

    document.addEventListener('customer:login', RebuyProducts.clearResult);
    document.addEventListener('customer:logout', RebuyProducts.clearResult);
    RebuyProducts.customerLog();
  }

  /**
   * The customerLog method is a special method of a class to clear
   * all product result.
   * @name customerLog
   * @kind function
   */
  static clearResult() {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.indexOf('rebuyProduct_') !== -1) sessionStorage.removeItem(key);
    });
  }

  /**
   * The customerLog method is a special method of a class to set
   * custom events for login and logout.
   * @name customerLog
   * @kind function
   */
  static customerLog() {
    const { customer } = window;
    if (!customer && localStorage.getItem('customer')) {
      localStorage.removeItem('customer');
      document.dispatchEvent(new CustomEvent('customer:logout'));
    } else if (customer && !localStorage.getItem('customer')) {
      localStorage.setItem('customer', `${customer}`);
      document.dispatchEvent(new CustomEvent('customer:login'));
    }
  }

  /**
   * The setCartData method is a special method of a class to set
   * up cart data to gloval variable.
   * @param {Event} event The represents an event which takes
   * place in the DOM.
   */
  static setCartData(event) {
    (async () => {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const data = await response.json();
      const oldCartSubtotal = window.cartSubtotal || 0;
      window.cartSubtotal = response.ok ? (data.total_price || 0) : 0;
      window.cartItems = (data?.items || []).reduce((c, { product_id: id, quantity }, index) => ({
        ...c,
        [`cart[items][${index}][product_id]`]: id,
        [`cart[items][${index}][quantity]`]: quantity,
      }), {});

      if (event?.type === 'rebuy:cart.change' || !event) document.dispatchEvent(new CustomEvent('rebuy-products:cart-update'));
    })();
  }

  /**
   * The rebuildPopUps method is a special method of a class to rebuild
   * rebuy widget popups.
   * @name rebuildPopUps
   * @kind function
   */
  static rebuildPopUps() {
    document.querySelectorAll('dialog[rebuy-widget-popup]').forEach((item) => {
      const dialog = item;
      const dialogRebuyProducts = dialog.querySelector('rebuy-products');
      if (!dialogRebuyProducts) return;
      dialogRebuyProducts.querySelectorAll('ul li').forEach((i) => i.remove());
      if (
        dialogRebuyProducts.api
        && dialogRebuyProducts.identifier
      ) dialogRebuyProducts.findRebuyWidget();
    });
  }

  /**
   * The findRebuyWidget method is a special method of a class to find
   * the widget with the correct identifier.
   */
  findRebuyWidget() {
    (async () => {
      const requestParameters = new URLSearchParams({
        key: `${this.api}`,
        ...(this.productId && {
          shopify_product_ids: this.productId,
        }),
        ...(this.collectionId && {
          shopify_collection_id: this.collectionId,
        }),
        ...(this.pagePath && {
          url: this.pagePath,
        }),
        ...(this.customerId && {
          shopify_customer_id: this.customerId,
        }),
        ...(this.limit && {
          limit: this.limit,
        }),
        cart_subtotal: `${window.cartSubtotal || 0}`,
        ...(Object.values(window.cartItems || {}).length > 0 && window.cartItems),
      });
      const response = await fetch(`https://rebuyengine.com/api/v1/custom/id/${this.identifier}?${requestParameters}`);
      const { data, error_message: errorMessage } = await response.json();
      if (!response.ok) throw Error(errorMessage || 'HTTP error');
      const activeProductList = (data || []).filter(
        ({ status }) => status === 'active',
      );

      if (!activeProductList.length) {
        this.closest('dialog').close();
        return;
      }
      
      activeProductList.forEach(({ handle, id }) => this.getCardProduct(handle, id));

      if (this.stickySidget || !this.columnsDesktop || !this.columnsMobile) return;
      this.setAttribute(
        'phone-nav-enable',
        `${!this.stickySidget && activeProductList.length > this.columnsMobile}`,
      );
      this.setAttribute(
        'desktop-nav-enable',
        `${!this.stickySidget && activeProductList.length > this.columnsDesktop}`,
      );
    })();
  }

  /**
   * The getCardProduct method is a special method of a class for
   * get cart product html for search page.
   * @name getCardProduct
   * @kind function
   * @param {string} handle The handle of a product.
   * @param {string} id The ID of a product.
   */
  async getCardProduct(handle, id) {
    const { root } = window.Shopify.routes;
    const result = sessionStorage.getItem(`rebuyProduct_${handle}_${root}`);
    if (result !== null) this.insertLi(result, id);
    else {
      const { sections } = this;
      const requestParameters = new URLSearchParams({ sections });
      const requestURL = `${this.url.origin}${root}/products/${handle}?${requestParameters}`;

      const htmlString = await fetch(requestURL)
        .then((response) => response.json())
        .then((data) => data[sections]);

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(htmlString, 'text/html');
      const { innerHTML } = htmlDoc.querySelector('.shopify-section');

      sessionStorage.setItem(`rebuyProduct_${handle}_${root}`, innerHTML);
      this.insertLi(innerHTML, id);
    }
  }

  /**
   * The insertLi method is a special method of a class for
   * insert li elements with correctly product data.
   * @name insertLi
   * @kind function
   * @param {string} innerHTML The product cart template.
   * @param {string} id The ID of a product.
   */
  insertLi(innerHTML, id) {
    const { attributes } = this.li;
    const li = document.createElement('li');
    [...(attributes || [])].forEach(({ name, nodeValue }) => {
      li.setAttribute(name, name === 'id' ? `${nodeValue}_${id}` : `${nodeValue}`);
    });
    li.innerHTML = innerHTML;
    this.ul.insertAdjacentElement('beforeend', li);
    this.slider = this.querySelector('[id^="Slider-"]');
    if (this.slider) {
      this.sliderItems = this.querySelectorAll(`[id="${this.slider.id}"] > [id^="Slide-"]`);
      this.initPages();
    }
    const dialog = this.closest('dialog[rebuy-widget-popup]');
    if (dialog && this.when !== undefined) {
      dialog.showModal();
      dialog.querySelectorAll('[name="add"]').forEach((i) => i.addEventListener('click', () => dialog.close()));
    }
  }
}

customElements.define('rebuy-products', RebuyProducts);
